import type { FunctionComponent } from 'react';

import './style.scss';

export const GhostCard: FunctionComponent = () => (
  <div styleName="container">
    <div styleName="inner">
      <div styleName="line" />
      <div styleName="line" />
      <div styleName="line" />
    </div>
  </div>
);
